import { ALL_COLS } from "./columns";

export function computeColorRanges(rows) {
  const ranges = {};
  for (const col of ALL_COLS.filter((c) => c.colored)) {
    const values = rows
      .map((r) => (col.getValue ? col.getValue(r) : r[col.key]))
      .filter((v) => v != null && !Number.isNaN(Number(v)))
      .map(Number);
    if (values.length === 0) continue;
    ranges[col.key] = [Math.min(...values), Math.max(...values)];
  }
  return ranges;
}

export function getCellColor(value, range) {
  if (value == null || !range || range[0] === range[1]) return null;
  const t = Math.max(0, Math.min(1, (value - range[0]) / (range[1] - range[0])));
  if (t < 0.5) {
    const s = t * 2;
    return `rgb(${Math.round(254 + s)}, ${Math.round(202 + 53 * s)}, ${Math.round(202 + 53 * s)})`;
  }
  const s = (t - 0.5) * 2;
  return `rgb(${Math.round(255 - 68 * s)}, 255, ${Math.round(255 - 47 * s)})`;
}
